import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Clients} from "./components/Clients";
import { Services } from "./components/Services";
import { Lenguajes } from "./components/Lenguajes";
import { Portafolio } from './components/Portafolio';
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Experience } from './components/Experience';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Clients />
      <Services />
      <Experience/>
      <Lenguajes/>
      <Portafolio/>
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
